const CreateStudyCard = ({ backgroundImage, onClick, width = "250px", height = "250px" }) => {
  return (
    <div
      className="overflow-hidden cursor-pointer  hover:shadow-lg transition-shadow rounded-xl"
      onClick={onClick}
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: height,
        width: width,
      }}
    >
      <div className="bg-opacity-80 text-white p-6 h-full flex  flex-col items-center justify-center text-center">
        <h3 className="text-3xl font-bold mb-2">Create</h3>
        <p className="text-3xl font-bold text-white">new study</p>
      </div>
    </div>
  )
}

export default CreateStudyCard
